import React from 'react'

export default ({
  qaTask,
  onComplete,
  onUnable
}) => (
  <div className='qa-task'>
    <p>{qaTask.description}</p>

    <div className='qa-task-controls'>
      <a onClick={onComplete}>
        <img src={completedUrl(qaTask)} />
      </a>

      <a onClick={onUnable}>
        <img src={unableUrl(qaTask)} />
      </a>
    </div>
  </div>
)

function completedUrl (qaTask) {
  if (qaTask.status === 'completed') {
    return require('../../images/task-completed-selected.svg')
  } else {
    return require('../../images/task-completed.svg')
  }
}

function unableUrl (qaTask) {
  if (qaTask.status === 'unable') {
    return require('../../images/task-cant-complete-selected.svg')
  } else {
    return require('../../images/task-cant-complete.svg')
  }
}



// WEBPACK FOOTER //
// ./src/components/qa-tasks/qa-task.js